import { useEffect, useMemo, memo, Suspense } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// @Utility
import { isUserLoggedIn } from "@core/auth/utils";
import lazyImport from "@utility/app/lazyImport";

// Redux & Action
import { setPasswordSmsPopup } from "@core/redux/actions/app/password";

// Components (No lazyImport for views/components)
const { Component: AlertApp } = lazyImport(() => import("views/components/Alert/index"));
const { Component: SnackbarApp } = lazyImport(() => import("views/components/Alert/Snackbar"));
const { Component: DemoApp } = lazyImport(() => import("views/components/Demo"));
const { Component: ImagePopup } = lazyImport(() => import("views/components/ImagePopup"));
const { Component: PasswordSms } = lazyImport(() => import("views/components/PasswordSms"));
const { Component: PopupContact } = lazyImport(() => import("views/components/PopupContact"));

const ConfigSet = memo(({ dataCMS }) => {
    const dataSetting = useSelector(state => state.reduxAppDataSetting.result);
    const snackbarData = useSelector(state => state.reduxAppSnackbar.snackbarData);
    const alertData = useSelector(state => state.reduxAppAlert);
    const demoData = useSelector(state => state.reduxAppDemo);
    const reduxAppPassword = useSelector(state => state.reduxAppPassword?.passwordPopup);
    const homeData = useSelector(state => state.reduxHome.result);
    const popupContactStatus = useSelector(state => state.reduxAppPopup.popupContact);

    const dispatch = useDispatch();

    const shouldShowPopupContact = useMemo(() => {
        return (dataCMS?.section_popup_contact_line === "1" || dataCMS?.section_popup_contact_line === 1)
            && isUserLoggedIn()
            && popupContactStatus;
    }, [dataCMS?.section_popup_contact_line, popupContactStatus]);

    useEffect(() => {
        if (homeData?.auth_sms === 1 || homeData?.auth_sms === true) {
            dispatch(setPasswordSmsPopup({ show: true, changePasswordForce: false }));
        }
    }, [homeData]);

    return (
        <Suspense fallback={<div />}>
            <ImagePopup agentImage={dataSetting?.agent_image} />

            {
                reduxAppPassword?.show && (
                    <PasswordSms show={reduxAppPassword?.show} changePasswordForce={reduxAppPassword?.changePasswordForce} />
                )
            }

            {snackbarData.statusShow && (
                <SnackbarApp snackbarData={snackbarData} />
            )}

            {alertData.show && (
                <AlertApp alertData={alertData} />
            )}

            {demoData.show && (
                <DemoApp demoData={demoData} />
            )}

            {shouldShowPopupContact && (
                <PopupContact popupContactShow={popupContactStatus} />
            )}
        </Suspense>
    );
});

export default ConfigSet;
